import Api from "@/api/lib/api";
import { toast } from "react-hot-toast";

export function printLoyaltyNativeCard(restaurantId, loyaltyId, card_type = "gift-card", payload = {}) {
  const requestBody = {
    restaurant_id: Number(restaurantId),
    card_type: typeof card_type === "string" ? card_type : "gift-card",
    ...(typeof card_type === "object" ? card_type : {}),
    ...payload,
  };

  return Api.post(`restaurant/${restaurantId}/loyalty/${loyaltyId}/print`, requestBody)
    .then((res) => {
      console.log("Loyalty card print response:", res);
      if (res?.data?.status === "success") {
        toast.success("Loyalty card printed successfully");
      } else {
        toast.error(res?.data?.message || "Failed to print loyalty card");
      }
      return res?.data;
    })
    .catch((err) => {
      console.error("Error printing loyalty card:", err);
      toast.error("An error occurred while printing the loyalty card");
      return { status: "failure", message: "An error occurred while printing the loyalty card" };
    });
}